import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Jsonsmkyu9xjl7fv as Json } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import { Properties3rdc3388jbgie as Properties } from '../../../../../kotlinx-serialization-kotlinx-serialization-properties/kotlinx/serialization/properties/Properties.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_getInstance3bmv1m2n6m7w7 as Companion_getInstance,
  Wrapper2y18qo0rjxh4n as Wrapper,
} from './serialization.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  mapOf2zpbbmyqk8xpf as mapOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  indexOf1xbs558u7wr52 as indexOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { StructureKind3lvezx2pbunxs as StructureKind } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  startsWith26w8qjqapeeq6 as startsWith,
  replaceFirst16v6kjg1scqx4 as replaceFirst,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { LogRoot_getInstance3817ahbflvs01 as LogRoot_getInstance } from '../debugger.js.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_DefaultSerializersModule(value) {
  _init_properties_urls_kt__kueezo();
  DefaultSerializersModule = value;
  set_DefaultJsonCurrent(Json(VOID, _set_DefaultSerializersModule_$lambda_rqdc00));
  set_UrlPropertiesCurrent(Properties(get_DefaultSerializersModule()));
}
function get_DefaultSerializersModule() {
  _init_properties_urls_kt__kueezo();
  return DefaultSerializersModule;
}
var DefaultSerializersModule;
function set_DefaultJsonCurrent(_set____db54di) {
  _init_properties_urls_kt__kueezo();
  DefaultJsonCurrent = _set____db54di;
}
function get_DefaultJsonCurrent() {
  _init_properties_urls_kt__kueezo();
  return DefaultJsonCurrent;
}
var DefaultJsonCurrent;
function set_UrlPropertiesCurrent(_set____db54di) {
  _init_properties_urls_kt__kueezo();
  UrlPropertiesCurrent = _set____db54di;
}
function get_UrlPropertiesCurrent() {
  _init_properties_urls_kt__kueezo();
  return UrlPropertiesCurrent;
}
var UrlPropertiesCurrent;
function get_DefaultJson() {
  _init_properties_urls_kt__kueezo();
  return get_DefaultJsonCurrent();
}
function get_UrlProperties() {
  _init_properties_urls_kt__kueezo();
  return get_UrlPropertiesCurrent();
}
function decodeFromString(_this__u8e3s4, serializer, value) {
  _init_properties_urls_kt__kueezo();
  var tmp = serializer.az().s11();
  if (tmp instanceof StructureKind()) {
    // Inline function 'kotlin.collections.associate' call
    var this_0 = split(value, charArrayOf([_Char___init__impl__6a9atx(38)]));
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap().fc(capacity);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var index = indexOf(element, _Char___init__impl__6a9atx(61));
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(substring(element, 0, index), decodeURIComponent(substring_0(element, index + 1 | 0)));
      destination.s3(pair.af_1, pair.bf_1);
    }
    return _this__u8e3s4.q50(serializer, destination);
  } else {
    if (value === 'NULL' && serializer.az().l11()) {
      return (null == null ? true : !(null == null)) ? null : THROW_CCE();
    }
    return _this__u8e3s4.q50(Companion_getInstance().d2j(serializer), mapOf(to('value', decodeURIComponent(value)))).kd7_1;
  }
}
function decodeFromStringMap(_this__u8e3s4, serializer, key, source) {
  _init_properties_urls_kt__kueezo();
  try {
    // Inline function 'kotlin.collections.filterKeys' call
    var result = LinkedHashMap().f6();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = source.d2().m1();
    while (_iterator__ex2g4s.n1()) {
      var entry = _iterator__ex2g4s.o1();
      var it = entry.e2();
      if (startsWith(it, key)) {
        result.s3(entry.e2(), entry.f2());
      }
    }
    // Inline function 'kotlin.collections.mapKeys' call
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination = LinkedHashMap().fc(mapCapacity(result.p1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_0 = result.d2().m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element = _iterator__ex2g4s_0.o1();
      var tmp = replaceFirst(element.e2(), key, 'value');
      var tmp$ret$4 = element.f2();
      destination.s3(tmp, tmp$ret$4);
    }
    var filtered = destination;
    if (filtered.i1())
      return null;
    return _this__u8e3s4.q50(Companion_getInstance().d2j(serializer), filtered).kd7_1;
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      LogRoot_getInstance().gcv(["Could not parse query parameter '" + key + "': " + e.message]);
      return null;
    } else {
      throw $p;
    }
  }
}
function encodeToString(_this__u8e3s4, serializer, value) {
  _init_properties_urls_kt__kueezo();
  var tmp;
  var tmp_0 = serializer.az().s11();
  if (tmp_0 instanceof StructureKind()) {
    var tmp_1 = _this__u8e3s4.p50(serializer, value).d2();
    tmp = joinToString(tmp_1, '&', VOID, VOID, VOID, VOID, encodeToString$lambda);
  } else {
    var tmp0_elvis_lhs = _this__u8e3s4.p50(Companion_getInstance().d2j(serializer), new (Wrapper())(value)).p3('value');
    tmp = encodeURIComponent(tmp0_elvis_lhs == null ? 'NULL' : tmp0_elvis_lhs);
  }
  return tmp;
}
function encodeToStringMap(_this__u8e3s4, serializer, value, key, out) {
  _init_properties_urls_kt__kueezo();
  if (value == null)
    return Unit_instance;
  // Inline function 'kotlin.collections.mapKeys' call
  var this_0 = _this__u8e3s4.p50(Companion_getInstance().d2j(serializer), new (Wrapper())(value));
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap().fc(mapCapacity(this_0.p1()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_0.d2().m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp = replaceFirst(element.e2(), 'value', key);
    var tmp$ret$1 = element.f2();
    destination.s3(tmp, tmp$ret$1);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  out.u3(destination);
}
function _set_DefaultSerializersModule_$lambda_rqdc00($this$Json) {
  _init_properties_urls_kt__kueezo();
  $this$Json.f29_1 = get_DefaultSerializersModule();
  $this$Json.q28_1 = true;
  return Unit_instance;
}
function DefaultJsonCurrent$lambda($this$Json) {
  _init_properties_urls_kt__kueezo();
  $this$Json.f29_1 = get_DefaultSerializersModule();
  $this$Json.q28_1 = true;
  return Unit_instance;
}
function encodeToString$lambda(it) {
  _init_properties_urls_kt__kueezo();
  return it.e2() + '=' + encodeURIComponent(it.f2());
}
var properties_initialized_urls_kt_rc3v9i;
function _init_properties_urls_kt__kueezo() {
  if (!properties_initialized_urls_kt_rc3v9i) {
    properties_initialized_urls_kt_rc3v9i = true;
    DefaultSerializersModule = EmptySerializersModule();
    DefaultJsonCurrent = Json(VOID, DefaultJsonCurrent$lambda);
    UrlPropertiesCurrent = Properties(get_DefaultSerializersModule());
  }
}
//region block: exports
export {
  get_DefaultJson as get_DefaultJson7vbyrb403mrj,
  get_DefaultSerializersModule as get_DefaultSerializersModule10h5j26es502p,
  set_DefaultSerializersModule as set_DefaultSerializersModulehpe9ajem91ea,
  get_UrlProperties as get_UrlProperties24r163uv67g3,
  decodeFromStringMap as decodeFromStringMap1klpgj0m9fuhr,
  decodeFromString as decodeFromString1e1s881w515pe,
  encodeToStringMap as encodeToStringMap10nt8ix1o4hj8,
  encodeToString as encodeToString2a3ryc7x3krzd,
};
//endregion

//# sourceMappingURL=urls.mjs.map
